import { Modal } from "@material-ui/core";
import React, { FunctionComponent, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./ModalPopup.scss";

const ModalPopup: FunctionComponent<any> = (props: any) => {
  const {
    body,
    toggleOpen,
    setOpen,
    classNameProps,
    closeButton,
    modalScrollClass,
  } = props;
  const [open, setModalOpen] = useState(toggleOpen);

  function handleClose() {
    setModalOpen(false);
    setOpen(false);
  }

  return (
    <div>
      <Modal open={open} onClose={handleClose} aria-label="modal-popup" className={modalScrollClass}>
        <div className={`modalpopup ${classNameProps}`} id="simple-modal-title">
          {body}
          {closeButton && (
            <span className="close-btn" onClick={handleClose}>
              {closeButton}
            </span>
          )}
        </div>
      </Modal>
    </div>
  );
};
export default ModalPopup;